<res-base-modal [modalTitle]="'Reprocess Documents Options'" [modalClass]="modalClass"
    [modalAutomationId]="automationId" [primaryButtonLabel]="'OK'" (primaryButtonActionEmt)="ok()"
    (closeButtonActionEmt)="closeModal()" [isPrimaryBtnEnabled]="!isBusy && okEnabled()"
    [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [modalHelpIndex]="modalHelpIndex" [modalHasVariableHeight]="true">

    <div>
        <div class="modal-row input-label-row">
            <label>Document Processing Timeout:</label>
            <input #docProcessingTimeout type="text" maxlength="3" (keypress)="restrictNumeric($event)"
                (blur)="parseNumeric('documentReprocessTimeout', 3, 180)" [(ngModel)]="documentReprocessTimeout"
                [data-automation-id]="automationId + '-document-processing-timeout-input'" title="Enter: 3 - 180"
                class="error-popover" containerClass="info" container="body" [popover]="errorPopoverTemplate"
                triggers="" #docRangeInfoPopover="bs-popover" placement="top" />
            <ng-template #errorPopoverTemplate>
                <span data-automation-id="reprocess-modal-doc-processing-timeout-info-label">{{docRangeInfoText}}</span>
                <i class="fa fa-close" (click)="docRangeInfoPopover.hide()"></i>
            </ng-template>
            <label>minutes</label>
        </div>
        <div class="modal-row header">
            <span>Reprocess Options</span>
        </div>
        <div class="modal-row">
            <button [attr.data-automation-id]="automationId + '-reprocess-documents-only-toggle-button'" type="button"
                [ngClass]="documentsOnly ? 'btn-group-active' : 'btn-group-default'" (click)="documentsOnly = true">
                <div>Reprocess Documents Only</div>
                <i class="fa fa-caret-up up-caret-active"></i>
            </button>
            <button [attr.data-automation-id]="automationId + '-reprocess-documents-with-children-toggle-button'"
                type="button" [ngClass]="documentsOnly ? 'btn-group-default' : 'btn-group-active'"
                (click)="documentsOnly = false">
                <div>Reprocess Documents With Children</div>
                <i class="fa fa-caret-up up-caret-active"></i>
            </button>
        </div>
        <div class="modal-row" *ngIf="documentsOnly == true">
            <res-custom-checkbox [attr.data-automation-id]="automationId + '-extract-from-container'"
                [(ngModel)]="extractFromContainer" content="Extract from Container"></res-custom-checkbox>
        </div>
        <div *ngIf="documentsOnly == false">
            <div class="modal-row">
                <res-custom-checkbox
                    [attr.data-automation-id]="automationId + '-sync-document-children-to-project-data'"
                    [(ngModel)]="syncChildrenToProjectData" content="Sync Document Children to Project Data">
                </res-custom-checkbox>
            </div>
            <div class="modal-row padded-row" *ngIf="hasTagPermissions">
                <res-custom-checkbox [attr.data-automation-id]="automationId + '-apply-parent-tags-to-children'"
                    [(ngModel)]="applyParentTags" content="Apply Parent Tags to Children"
                    [disabled]="!syncChildrenToProjectData"></res-custom-checkbox>
            </div>
            <div class="modal-row padded-row" *ngIf="hasTagPermissions">
                <res-custom-checkbox [attr.data-automation-id]="automationId + '-apply-new-tags-to-children'"
                    [(ngModel)]="applyNewTags" content="Apply New Tags to Children"
                    [disabled]="!syncChildrenToProjectData"></res-custom-checkbox>
                <button type="button" [attr.data-automation-id]="automationId + '-select-tags-button'"
                    class="secondary-button" (click)="selectTags()"
                    [disabled]="!applyNewTags || !syncChildrenToProjectData">
                    <i class="fa fa-tags color-blue-01"></i>Select Tags ...
                </button>
                <span [ngClass]="[(!applyNewTags || !syncChildrenToProjectData) ? 'disabled' : '']">Selected:<span
                        [attr.data-automation-id]="automationId + '-selected-tags-label'">{{selectedTags.length}}</span></span>
            </div>
            <div class="modal-row input-label-row">
                <label>Archive Processing Timeout:</label>
                <input #msgProcessingTimeout type="text" (keypress)="restrictNumeric($event)"
                    (blur)="parseNumeric('msgTimeout', 10, 1200)" [(ngModel)]="msgTimeout" maxlength="4"
                    title="Enter: 10 - 1200"
                    [attr.data-automation-id]="automationId + '-message-archive-processing-timeout-input'"
                    class="error-popover" containerClass="info" container="body" [popover]="errorPopoverTemplate"
                    triggers="" #rangeInfoPopover="bs-popover" placement="top" />
                <ng-template #errorPopoverTemplate>
                    <span data-automation-id="reprocess-modal-timeout-info-label">{{rangeInfoText}}</span>
                    <i class="fa fa-close" (click)="rangeInfoPopover.hide()"></i>
                </ng-template>
                <label>minutes</label>
            </div>
        </div>
    </div>
</res-base-modal>
